import GLightbox from "glightbox";

var doc = document.documentElement;

export const lightbox = function (el) {
    console.log("glightbox");
    var top = 0;
    el.querySelectorAll(".gl").forEach(function (item) {
        item.addEventListener("click", function () {
            top = document.documentElement.scrollTop;
            console.log("get top", top);
        });
    });
    var lightbox = GLightbox({
        loop: true,
        selector: ".gl",
    });

    lightbox.on("close", () => {
        console.log("set top", top);
        doc.scrollTop = top;
    });
};
